import { HRM_PERMISSIONS } from '@/constant/hr/permissions';
import { useHasPermission } from '@/hooks/use-has-permission';
import { EmployeesPagingResult } from '../types/employee.types';
import { useGetMyEmployee } from './use-employees';

/**
 * Whether the signed-in person must still complete their own profile before using the app: their
 * `UserProfileDetail` says `IsProfileCompleted: false` (set on creation when the creator's organization
 * requires extended info, see `createEmployee`). A record saved before that flag existed has no value;
 * it is only forced for someone holding `hrm::people::require-extended-info`. A person with no profile
 * record is never forced, since there is nothing for them to fill in.
 */
export const useProfileCompletion = () => {
  const requiresExtendedInfo = useHasPermission(HRM_PERMISSIONS.PEOPLE.REQUIRE_EXTENDED_INFO);
  const { data, isLoading, isFetching } = useGetMyEmployee();
  const employee = (data as { Employees?: EmployeesPagingResult } | undefined)?.Employees
    ?.items?.[0];
  const isProfileCompleted = employee?.IsProfileCompleted;

  return {
    requiresExtendedInfo,
    isLoading,
    isFetching,
    isCompletionRequired:
      Boolean(employee) &&
      (isProfileCompleted === false || (requiresExtendedInfo && isProfileCompleted !== true)),
  };
};
